import { Component, Input, Output, EventEmitter, ViewChild, OnInit, DoCheck } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { DataBagService } from 'src/app/common/data-bag.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { LocationDescriptionAddComponent } from './location-description-add/location-description-add.component';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}
@Component({
	selector: 'app-location-descriptions',
	templateUrl: './location-descriptions.component.html',
	styleUrls: ['./location-descriptions.component.css'],
})
export class LocationDescriptionsComponent implements OnInit, DoCheck {
	@Input() data: any;
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();
	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	@ViewChild(MatSort) sort: MatSort;
	displayedColumns: string[] = ['name', 'description', 'edit'];
	dialogConfig: MatDialogConfig;
	dialogWithForm: MatDialogRef<LocationDescriptionAddComponent>;
	private descriptionheaders: Array<any> = [];
	private convertedDescription;
	constructor(
		private readonly bag: DataBagService,
		private readonly dialogModel: MatDialog,
	) {}

	ngOnInit(): void {
		this.bag.get('/description_header/?limit=9999', (result, error) => {
			this.descriptionheaders = result.results;
		});
	}

	ngDoCheck() {
		const reg = /<[^>]*>/g;
		if (this.data.locationDescriptions != undefined) {
			this.data.locationDescriptions.map((item) => {
				this.convertedDescription = item.description.replace(reg, ' ');

				item.convertedDescription = this.convertedDescription;
				return item;
			});
		}
	}

	dialogForm() {
		const dialogWithForm = this.dialogModel.open(LocationDescriptionAddComponent, {
			width: '60%',
			data: {
				descriptionheaders: this.descriptionheaders,
				header: null,
				description: null,
			},
		});

		dialogWithForm.afterClosed().subscribe((result) => {
			if (result == undefined || result.description == null || result.description == '') {
				return false;
			}
			const selectedOptionHeader = result.descriptionheaders.find((obj) => obj.id === result.header);

			this.data.locationDescriptions.push({
				id: null,
				descriptionHeader: selectedOptionHeader,
				description: result.description,
			});
			this.table.renderRows();
		});
	}

	editForm(element) {
		this.bag.get('/description_header/' + element.descriptionHeader.id, (result, error) => {
			const dialogWithForm = this.dialogModel.open(LocationDescriptionAddComponent, {
				width: '60%',
				data: {
					descriptionheaders: this.descriptionheaders,
					header: result.id,
					description: element.description,
				},
			});

			dialogWithForm.afterClosed().subscribe((result) => {
				if (result == undefined || result.description == null || result.description == '') {
				} else {
					result.descriptionheaders = result.descriptionheaders.find((obj) => obj.id === result.header);
				}
				this.updateRowData(result, element, result.descriptionheaders);
				this.table.renderRows();
			});
		});
	}

	updateRowData(data_obj, row_obj, headerName) {
		this.data.locationDescriptions.forEach((value) => {
			if (value.id === row_obj.id) {
				value.description = data_obj.description;
				value.descriptionHeader = headerName;
			}
		});
	}

	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.data.locationDescriptions, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	deleteDescription(index) {
		this.data.locationDescriptions.splice(index, 1);
		this.table.renderRows();
	}
}
